import React from "react";
import { Helmet } from "react-helmet";

function MillwoodsAdminCallLogDocs() {
  return (
    <div className="w-full h-screen flex justify-center items-center bg-gray-100 p-4">
      <Helmet>
        <meta charSet="utf-8" />
        <title>CRM Call Log Admin Guide | Millwoods Travels</title>
      </Helmet>
      <div className="w-full h-full max-w-4xl p-4 bg-white shadow-lg rounded-lg">
        <iframe
          src="https://docs.google.com/document/d/1EpFnTI0Zz2NLuBeGCM43BiU3t2txu3tMC-2Al9Gt86w/preview"
          className="w-full h-full"
        ></iframe>
      </div>
    </div>
  );
}

export default MillwoodsAdminCallLogDocs;
